module.exports = __webpack_public_path__ + "2c6f07f3cd06dd5b7318c2b1a2db12cc.svg";